import React from 'react'
import cx from 'classnames'
import { BtnV2, l } from '@manychat/manyui'

import { useKeyDown } from 'common/core/coreHooks'

import cm from './Heading.module.css'

interface HeadingProps {
  onBackClick?: () => void
  label: string
}

export const Heading = ({ onBackClick, label }: HeadingProps) => {
  useKeyDown({
    key: 'Backspace',
    onPress: onBackClick,
  })

  return (
    <div className={cx(onBackClick && cm.heading_withBackButton)}>
      {onBackClick && (
        <BtnV2
          onClick={onBackClick}
          className={cm.backButton}
          onlyIcon="ChevronLeft"
          variant="ghost-primary"
          ariaLabel={l.translate('Open previous step')}
        />
      )}

      <h2 className="m-0 text-subheading text-ellipsis" title={label}>
        {label}
      </h2>
    </div>
  )
}
